import groupBy from 'lodash/groupBy'
import React from 'react'
import { WithTranslation, withTranslation } from 'react-i18next'
import { BsDashSquareFill, BsFillPlusSquareFill } from 'react-icons/bs'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import styled from 'styled-components'

import { GroupOffers } from '../../common/components/GroupOffers'
import { getAllActivities, getCurrentUser, getGroupsByPrograms } from '../../common/requests'
import { routes } from '../../common/routes'
import User from '../../dtos/User'
import { IActivity, ICalendarGroup } from '../calendar/types'

const TreeViewContainer = styled.div`
  padding: 40px;
`

const TreeLevel = styled.div`
  & > & {
    margin-left: 20px;
  }
`
const Option = styled.div`
  cursor: pointer;
`

const OptionName = styled.span`
  margin-left: 10px;
`

const PlusIcon = styled(BsDashSquareFill)`
  color: ${({theme}) => theme.primary}
`

const MinusIcon = styled(BsFillPlusSquareFill)`
  color: ${({theme}) => theme.primary}
`

interface ITreeViewProps extends RouteComponentProps, WithTranslation {
  programIds: number[]
  organizationId: number
  organizationSlug: string | undefined
  shopUrl: string | undefined
}

interface ITreeViewState {
  activities: IActivity[] | undefined
  selectedActivityId: string | null
  groups: ICalendarGroup[] | undefined

  openedActivities: number[]
  openedGroups: number[]

  isLoading: boolean
  isLoggedIn: boolean
  user: Partial<User> | null
}

export class TreeView extends React.Component<ITreeViewProps, ITreeViewState> {

  state: ITreeViewState = {
    activities: undefined,
    selectedActivityId: null,
    groups: undefined,

    openedActivities: [],
    openedGroups: [],

    user: null,
    isLoading: true,
    isLoggedIn: false,
  }

  async componentDidMount() {
    const user = await getCurrentUser() || null
    this.setState({
      user,
      isLoggedIn: Boolean(user),
      isLoading: false,
    })

    return Promise.all([
      getGroupsByPrograms({
        organizationId: this.props.organizationId,
        programIds: this.props.programIds
      }),
      getAllActivities({ organizationId: this.props.organizationId })
    ])
      .then(([{ groups }, { activities }]) => {
        const openedId = this.props.location.hash.replace('#', '')
        if (groups.find(x => String(x.activity.id) === openedId)) {
          this.setState({
            groups,
            activities
          })
        } else {
          this.setState({
            groups,
            activities
          })
        }
      })
      .catch(e => {
        console.error(e)
      })
  }

  goToLogin = () => {
    const redirectUrl = encodeURIComponent(`${this.props.location.pathname}${this.props.location.search}${this.props.location.hash}`)
    this.props.history.push(`${routes.authentication}/${routes.authenticationSubRoutes.login}?redirect_url=${redirectUrl}`)
  }

  getSelectedGroup = () => {
    return this.state.groups && this.state.groups
      .find(x => String(x.activity.id) === String(this.state.selectedActivityId))
  }

  toggleActivity = (activityId: number) => {
    this.setState({
      openedActivities: this.state.openedActivities.includes(activityId)
        ? this.state.openedActivities.filter(x => x !== activityId)
        : [...this.state.openedActivities, activityId]
    })
  }

  toggleGroup = (groupId: number) => {
    this.setState({
      openedGroups: this.state.openedGroups.includes(groupId)
        ? this.state.openedGroups.filter(x => x !== groupId)
        : [...this.state.openedGroups, groupId]
    })
  }

  render() {
    const options: Record<number, ICalendarGroup[]> = groupBy(this.state.groups, x => x.activity.id)

    return (
      <TreeViewContainer>
        {
          !this.state.activities &&
          <div>{this.props.t('offers.loading')}</div>
        }
        {
          this.state.activities &&
          Object.entries(options).map(([activityId, groups]) => {
            return (
              <TreeLevel>
                <Option onClick={() => this.toggleActivity(Number(activityId))}>
                  {
                    this.state.openedActivities.includes(Number(activityId))
                      ? <PlusIcon />
                      : <MinusIcon />
                  }
                  <OptionName>
                    {groups[0].activity.name}
                  </OptionName>
                </Option>
                {
                  this.state.openedActivities.includes(Number(activityId)) &&
                  groups.map(group => {
                    const selectedActivity = this.state.activities && this.state.activities
                      .find(x => String(x.id) === String(activityId))
                    return (
                      <TreeLevel>
                        <Option onClick={() => this.toggleGroup(group.id)}>
                          {
                            this.state.openedGroups.includes(group.id)
                              ? <PlusIcon />
                              : <MinusIcon />
                          }
                          <OptionName>
                            {group.name}
                          </OptionName>
                        </Option>
                        {
                          this.state.openedGroups.includes(group.id) && selectedActivity &&
                          <GroupOffers
                            user={this.state.user}
                            activity={selectedActivity}
                            group={group}
                            shopUrl={this.props.shopUrl}
                            goToLogin={this.goToLogin}
                            closeButton={false}
                            organizationSlug={this.props.organizationSlug}
                          />
                        }
                      </TreeLevel>
                    )
                  })
                }
              </TreeLevel>
            )
          })
        }
      </TreeViewContainer>
    )
  }
}

export default withRouter(withTranslation()(TreeView));
